@import '../../../theme.scss';

verdocs-templates-list {
  display: flex;
  padding: 10px;
  font-size: 18px;
  flex-wrap: nowrap;
  border-radius: 6px;
  color: $label-color;
  flex-direction: column;
  font-family: $primary-font;

  .header {
    width: 100%;
    row-gap: 4px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 12px;
    margin: 0 0 10px 0;
    align-items: center;
    flex-direction: row;

    .filter {
      width: 150px;
    }

    verdocs-text-input {
      margin: 0;

      input {
        height: 32px;
      }
    }
  }

  .filter {
    align-items: center;
  }

  .template-placeholder {
    height: 48px;
    flex: 0 0 48px;
    margin: 5px 0;
    border-radius: 5px;
    background: $verdocs-grey-3;
  }

  .template {
    width: 100%;
    margin: 2px 0;
    border: 1px solid #ffffff;
    background: $verdocs-grey-4;

    &:hover {
      cursor: pointer;
      background: #ededff;
      border: 1px solid #a7a7f5;
    }

    .inner {
      gap: 12px;
      display: flex;
      padding: 8px 14px;
      border-radius: 5px;
      flex-direction: row;
      align-items: center;
      container-type: inline-size;

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  .name {
    flex: 1;
    display: flex;
    color: black;
    font-size: 16px;
    //margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    @media screen and (max-width: 1300px) {
      font-size: 16px;
    }

    @media screen and (max-width: 700px) {
      //flex: 0;
    }
  }

  .spacer {
    margin: 0;
    height: 30px;
    flex: 0 0 1px;
    display: flex;
    border-right: 1px solid #dad8dd;

    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .empty-text {
    font-size: 20px;
    text-align: center;
    margin: 16px 0 0 0;
    padding: 80px 80px;
    border: 2px solid #ccc;
  }

  .usage,
  .ownership,
  .last-used {
    gap: 10px;
    color: #444;
    display: flex;
    font-size: 16px;
    margin: 0 0 0 10px;
    align-items: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    span,
    svg {
      width: 24px;
      height: 24px;
    }

    span {
      display: block;
    }
  }

  verdocs-template-star {
    @media screen and (max-width: 700px) {
      display: none;
    }
  }

  .ownership {
    flex: 0 0 100px;

    @media screen and (max-width: 700px) {
      display: none;
    }
  }

  .last-used {
    flex: 0 0 130px;
  }

  .usage {
    flex: 0 0 60px;
  }

  .header-row {
    display: none;
  }

  table {
    container-type: size;
    max-width: 100%;
    overflow: hidden;
    table-layout: fixed;
  }

  .data-row {
    cursor: pointer;
    background: #ededff;
    border: 1px solid #a7a7f5;
  }

  .data-col {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .col-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  verdocs-templates-list {
    @container (max-width:700 px) {
      .col-starred {
        display: none;
      }
    }
  }
}
